var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _vm._v(
        "\n        TotalAvailableMemoryBytes: " +
          _vm._s(_setup.modelSystemStatsQueryV1.TotalAvailableMemoryBytes)
      ),
      _c("br"),
      _vm._v(
        "\n        WorkingSet64: " +
          _vm._s(_setup.modelSystemStatsQueryV1.WorkingSet64)
      ),
      _c("br"),
      _vm._v(
        "\n        TotalMemory: " +
          _vm._s(_setup.modelSystemStatsQueryV1.TotalMemory)
      ),
      _c("br"),
      _vm._v(
        "\n        TotalAllocatedMemory: " +
          _vm._s(_setup.modelSystemStatsQueryV1.TotalAllocatedMemory)
      ),
      _c("br"),
      _vm._v(
        "\n        Gen0Collections: " +
          _vm._s(_setup.modelSystemStatsQueryV1.Gen0Collections)
      ),
      _c("br"),
      _vm._v(
        "\n        Gen1Collections: " +
          _vm._s(_setup.modelSystemStatsQueryV1.Gen1Collections)
      ),
      _c("br"),
      _vm._v(
        "\n        Gen2Collections: " +
          _vm._s(_setup.modelSystemStatsQueryV1.Gen2Collections)
      ),
      _c("br"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }